import React from 'react';
import { ExternalLink, Gift, Star, TrendingUp } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: 'Lottomart',
      url: 'https://lottomart.com/',
      bonus: '100% up to £100',
      description: 'Double your first deposit and dive into over 4,000 thrilling games. From slots to live casino, your perfect match awaits.',
      icon: <Gift className="text-yellow-400" size={32} />,
      gradient: 'from-yellow-500/20 to-orange-500/20',
      borderColor: 'border-yellow-400/30',
    },
    {
      id: 2,
      name: 'Boylesports',
      url: 'https://www.boylesports.com/',
      bonus: 'Up to £100 in free bets + £70 bonus',
      description: 'Start with free bets and bonus cash. Experience premium sports betting and casino action with trusted reliability.',
      icon: <TrendingUp className="text-green-400" size={32} />,
      gradient: 'from-green-500/20 to-emerald-500/20',
      borderColor: 'border-green-400/30',
    },
    {
      id: 3,
      name: 'Fafabet',
      url: 'https://www.fafabet.co.uk/',
      bonus: 'Up to £50 Free Bet + £20 Casino Bonus',
      description: 'Get rewarded twice with free bets and casino bonus. Fast payouts and a massive game library at your fingertips.',
      icon: <Star className="text-blue-400" size={32} />,
      gradient: 'from-blue-500/20 to-cyan-500/20',
      borderColor: 'border-blue-400/30',
    },
  ];

  return (
    <section id="offers" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-transparent to-slate-800/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Exclusive Casino Offers
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Handpicked bonuses from the UK's most trusted operators. 
            Claim your welcome package and start winning today.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              className={`glass rounded-2xl p-8 hover:scale-105 transition-all duration-300 ${offer.borderColor} border-2 relative overflow-hidden group`}
            >
              {/* Background Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${offer.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
              
              <div className="relative z-10">
                {/* Icon */}
                <div className="mb-6">
                  {offer.icon}
                </div>

                {/* Casino Name */}
                <h3 className="text-2xl font-bold text-white mb-3">{offer.name}</h3>

                {/* Bonus */}
                <div className="mb-4">
                  <span className="inline-block glass px-4 py-2 rounded-lg text-yellow-400 font-semibold text-sm mb-2">
                    Welcome Bonus
                  </span>
                  <p className="text-xl font-bold text-white">{offer.bonus}</p>
                </div>

                {/* Description */}
                <p className="text-white/70 mb-6 leading-relaxed">
                  {offer.description}
                </p>

                {/* CTA Button */}
                <a
                  href={offer.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 glass px-6 py-3 rounded-xl text-white font-semibold hover:bg-white/20 transition-all duration-300 w-full justify-center group/btn"
                >
                  <span>Claim Offer</span>
                  <ExternalLink className="group-hover/btn:translate-x-1 transition-transform" size={18} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;

